<template>
  <v-list
    v-if="items.length > 0"
    style="min-width: 100% !important; overflow: auto;"
    :style="
      items.length > 0 && !$vuetify.breakpoint.mobile
        ? 'height: 60vh !important;'
        : ''
    "
  >
    <template v-for="item in items">
      <v-list-item
        :key="item.game_id"
        @click="$emit('openGameInformationDialog', item)"
      >
        <v-list-item-avatar
          rounded="0"
          style="border-radius: 8px !important"
          class="d-flex flex-column "
        >
          <v-img
            v-if="!gamesWithImageError.includes(item.title_game)"
            :src="item.avatar"
            @error="gamesWithImageError.push(item.title_game)"
          ></v-img>

          <v-icon v-else class="d-flex align-center" color="primary">
            mdi-poker-chip
          </v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title
            v-html="item.title_game"
            style="white-space: normal;"
          />
          <v-list-item-subtitle
            v-html="item.name_provider"
            style="color: #9D9D9D; font-size: 12px; white-space: normal;"
          />

          <v-list-item-subtitle>
            <v-row wrap no-gutters>
              <v-chip
                v-for="category in item.categories"
                :key="category"
                outlined
                :x-small="$vuetify.breakpoint.mobile"
                :small="!$vuetify.breakpoint.mobile"
                class="text-capitalize mt-1 mr-1"
              >
                {{ category }}
              </v-chip>
            </v-row>
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-btn
          v-if="$store.state.logged.status"
          color="primary"
          class="text-capitalize"
          x-small
          outlined
          fab
        >
          <v-icon class="material-icons-round">
            mdi-play
          </v-icon>
        </v-btn>

        <v-icon v-else class="material-icons-round" color="primary">
          mdi-information-outline
        </v-icon>
      </v-list-item>
    </template>

    <div v-if="filteredGamesLeft.length > 0" class="d-flex justify-center">
      <v-btn
        small
        outlined
        color="primary"
        class="text-capitalize mt-6 mb-2"
        @click="$emit('loadMore')"
      >
        {{ $t("newCasino.loadMore") }}
      </v-btn>
    </div>
  </v-list>
</template>

<script>
export default {
  props: ["items", "filteredGamesLeft"],

  data: () => ({
    gamesWithImageError: [],
  }),
};
</script>
